export default "__VITE_ASSET__7688c512__"